import { useCreateRuleFormContext } from 'context/FormContext';
import { Text } from '@mantine/core';
import { NumberOfMeasurementFields } from './NumberOfMeasurementFields';
import { NumberOfDaysFields } from './NumberOfDaysFields';
import { AlgorithmIndicatorFields } from './AlgorithmIndicatorFields';
import { HeartRateFields } from './HeartRateFields';
import { SymptomsFields } from './SymptomsFields';
import { SymptomSeverityFields } from './SymptomSeverityFields';
import { ActivityFields } from './ActivityFields';
import { ReviewedLabelFields } from './ReviewedLabelFields';
import { IncludeBadQualityField } from './IncludeBadQualityField';

export const HeartRhythmMeasurementFields = () => {
  const { errors } = useCreateRuleFormContext();
  return (
    <>
      <NumberOfMeasurementFields />
      <NumberOfDaysFields />
      <AlgorithmIndicatorFields />
      <ReviewedLabelFields />
      <HeartRateFields />
      <SymptomsFields />
      <SymptomSeverityFields />
      <ActivityFields />
      <IncludeBadQualityField />
      <Text c={'var(--mantine-color-error)'} size={'sm'} mt={'xs'}>
        {errors['data.heartRhythmMeasurement.oneConditionEnabled']}
      </Text>
    </>
  );
};
